<template>
  <f7-page class="page-mentor-generate">
    <f7-navbar :sliding="false">
      <f7-nav-left back-link="Trở lại"></f7-nav-left>
      <f7-nav-title sliding>LIÊN KẾT TELEGRAM</f7-nav-title>
    </f7-navbar>
    <f7-block inset strong>
      Liên hệ với
      <f7-link external target="_blank" :href="`https://t.me/${bot_link}`">KTSố Bot</f7-link>
      (<f7-link external target="_blank" :href="`https://t.me/${bot_link}`">https://t.me/{{ bot_link }}</f7-link>) thông qua Telegram để lấy mã kích hoạt
    </f7-block>
    <f7-list inset>
      <f7-list-input
          outline
          floating-label
          label="Mã kích hoạt"
          :value="form_generate.otp"
          @input="form_generate.otp = $event.target.value">
      </f7-list-input>
    </f7-list>
    <f7-block inset>
      <f7-button fill color="primary" @click.prevent="submitFormGenerate">
        XÁC NHẬN
      </f7-button>
    </f7-block>
  </f7-page>
</template>
<script>
import {mapState} from 'vuex';

export default {
  computed:{
    ...mapState(['bot_link']),
  },
  data(){
    return {
      form_generate:{
        otp:''
      }
    }
  },
  methods:{
    submitFormGenerate(){
      if(this.form_generate.otp === ''){
        this.$f7.dialog.alert('Vui lòng nhập mã kích hoạt', 'LỖI');
        return false;
      }

      this.$f7.preloader.show();

      this.$store.dispatch('telegramActive', this.form_generate)
        .then(() => {
          return this.$store.dispatch('getMe');
        })
        .then(() => {
          this.$f7.preloader.hide();
          this.$f7.dialog.alert('Liên kết thành công', 'THÔNG BÁO', () => {
            this.$f7.views.main.router.navigate('/');
          });
        })
        .catch((error) => {
          this.$f7.preloader.hide();
          this.$f7.dialog.alert(error, 'LỖI');
        });
    }
  }
};
</script>
